import { PasswordValidation } from 'helpers/validations/password';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  password,
  object,
  ObjectSchema,
  string,
} from 'libs/form';
import { TFunc } from 'libs/i18n';

export interface RestorePasswordFormType {
  password: string;
  otpCode?: string;
}

export const CODE_LENGTH = 6;

export const getSchema = (
  t: TFunc,
  passwordValidation: PasswordValidation
): ObjectSchema<RestorePasswordFormType> =>
  object({
    password: password(passwordValidation, t),
    otpCode: string().min(CODE_LENGTH),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<RestorePasswordFormType>();

export type FormErrors = FormErrorsBase<RestorePasswordFormType>;
